import { Customerdatasource } from './../datasource/customer.datasource';
import { CustomersService } from './../services/customer.service';
import { Component, ElementRef, OnInit, ViewChild, ChangeDetectorRef, Input, Renderer2 } from '@angular/core';
import { debounceTime, distinctUntilChanged, skip, tap } from 'rxjs/operators';
import { fromEvent, merge, Subscription } from 'rxjs';
import { MatPaginator, MatDatepickerInputEvent } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router'
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { CustomerModel } from '../models/customer.model';
import { CustomerEditDialogComponent } from './customer-edit/customer-edit.dialog.component';
import { MatDrawer } from '@angular/material/sidenav';
import { Platform } from '@angular/cdk/platform';

@Component({
  selector: 'app-my-customers',
  templateUrl: './my-customers.component.html',
  styleUrls: ['./my-customers.component.css'],
  providers: [DatePipe]
})
export class MyCustomersComponent implements OnInit {
  customerStatusList: any[] = [];  // Initialize as an empty array or with data
  referralList: any[] = [];
  dataSource: Customerdatasource
  displayedColumns: string[] = ['companyname', 'contactperson', 'designation', 'mobile', 'emailid'];
  @ViewChild('drawer', { static: true }) drawer: MatDrawer; // Reference the drawer
  isMobile: boolean = false;
  isDrawerOpen = false;

  private subscriptions: Subscription[] = [];
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild('searchInput', { static: true }) searchInput: ElementRef;
  customerFilterList = {
    from: 1,
    to: 10,
    text: '',
    userId: '',
    fromDate: '',
    toDate: '',
    search: ''
    // paymentStatusId:''
  }
  businessResult: any[];
  diplaycustomerFilterList: {};
  newfilterForm: FormGroup;
  currentUser: any;
  current: Date = new Date();
  showError: boolean = false;
  Fromdate: Date;
  // public paymentStatusList = [
  // 	{ value: 1, viewValue: 'Pending' },
  // 	{ value: 2, viewValue: 'Approved' },
  //   {value: 3, viewValue: 'Rejected' },
  // ];
  // paymentStatusValue: any;
  currentUserData: string;
  statusName = [];
  translate: any;
  toastrService: any;
  selectedActionId: number;
  referBy: string;
  lrmId: number;
  userName: any;
  opportunityId: any;
  referByCode: string;
  currentScroll: number;
  data: any;

  constructor(private cutomerservice: CustomersService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private chRef: ChangeDetectorRef,
    private dialog: MatDialog,
    private _cookieService: CookieService,
    private toastr: ToastrService,
    private router: Router,
    private http: HttpClient,
    private platform: Platform,
    private render: Renderer2

  ) {     
    // if(this.isDrawerOpen === true){
    // this.render.setStyle(document.body, 'overflow','hidden');
  // } 

}

  ngOnInit() {
    this.isMobile = this.platform.ANDROID || this.platform.IOS;
    // this.currentUser = JSON.parse(localStorage.getItem('responseData'));
    // this.currentUserData = JSON.parse(this._cookieService.get('currentUser'));
    // this.createFilterForm();
    this.diplaycustomerFilterList = {};
    this.dataSource = new Customerdatasource(this.cutomerservice);
    const entitiesSubscription = this.dataSource.entitySubject.pipe(
      skip(1),
      distinctUntilChanged()
    ).subscribe(res => {
      this.businessResult = res;
      this.referBy = this.businessResult[0].ReferralUserId;
    });
    this.getDashboard();
    this.dataSource.loadCustomers(this.customerFilterList);
    this.subscriptions.push(entitiesSubscription);
    // console.log(this.dataSource.loadCustomers(this.customerFilterList));

    // this.cutomerservice.getCustomFields();
  }

  ngAfterViewInit() {
    const searchSubscription = fromEvent(this.searchInput.nativeElement, 'keyup').pipe(
      debounceTime(500),
      distinctUntilChanged(),
      tap(() => {
        this.paginator.pageIndex = 0;
        this.loadCustomerPage();
      })
    )
      .subscribe();
    this.subscriptions.push(searchSubscription);
    
    const paginatorSubscriptions = merge(this.paginator.page).pipe(
      tap(() => this.loadCustomerPage())
    )
      .subscribe();
    this.subscriptions.push(paginatorSubscriptions);
    this.loadCustomerPage();
  }


  loadCustomerPage() {
    if (this.paginator.pageIndex < 0 || this.paginator.pageIndex > (this.paginator.length / this.paginator.pageSize))
      return;
    // Calculate the correct "from" and "to" values
    this.customerFilterList.from = this.paginator.pageIndex * this.paginator.pageSize + 1;
    this.customerFilterList.to = (this.paginator.pageIndex + 1) * this.paginator.pageSize;
    this.customerFilterList.text = this.searchInput.nativeElement.value;
    this.dataSource.loadCustomers(this.customerFilterList);
    // this.getDashboard(this.customerFilterList);
    this.chRef.detectChanges();
  }

  getDashboard() {
    // this.cutomerservice.getCustomer(CustomerFilterList)
    // .pipe(map(response => {
    //   if(response['Status'] == 200) {
    //     this.dashboardRecord = response['data'];
    //   }
    // }))
    // .subscribe();
    const dashboardSubscription = this.dataSource.displaycustomerFilterList.subscribe(res => {
      this.diplaycustomerFilterList = res;
    });
    this.subscriptions.push(dashboardSubscription);
  }
  viewRejectedReason(reason) {
    // console.log(reason)
    // this.dialog.open(MybusinessRejectDialogComponent, { data: reason, width: '400px' });
  }


  view(element: any) {
    this.dialog.open(CustomerEditDialogComponent, { data: { action: 'view', userData: element }, width: '900px' });
    console.log('hhh',element);
    this.data = element
  }

  openDialog() {
    this.dialog.open(CustomerEditDialogComponent);
  }


  signout(currentUser: any) {
    localStorage.clear();
    console.log(currentUser);
    this.toastr.success('Sign Out Successfully');
    this.router.navigate(['']);
  }
  addCustomer() {
    const newCustomer = new CustomerModel();
    newCustomer.clear(); // Set all defaults fields
    // this.editCustomer(newCustomer);
    const dialogRef = this.dialog.open(CustomerEditDialogComponent, { data: { action: 'add' }, panelClass: 'customer-dialog', width: '900px', });
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      } else {
        this.ngOnInit();
      }

    });
  }

  restrict(event: MatDatepickerInputEvent<Date>) {
    this.Fromdate = event.value;
    if (this.newfilterForm.controls['FromDate'].touched) {
      this.newfilterForm.controls['ToDate'].setValidators(Validators.required);
      this.newfilterForm.controls['ToDate'].updateValueAndValidity();
      this.showError = true;
    }

    if (this.newfilterForm.controls['ToDate'].value) {
      this.showError = false;
    }
  }
  export() {
    let Referbyid = this.referBy.toString();
    console.log(Referbyid);

    this.cutomerservice.fileExport(this.customerFilterList, Referbyid).subscribe(res => {
      // this.isloading = false
      // console.log("res", res)
    })
  }
  editCustomer(customer: CustomerModel) {
    // let saveMessageTranslateParam = 'APP.CUSTOMERS.EDIT.';
    // saveMessageTranslateParam += customer.LeadId > 0 ? 'UPDATE_MESSAGE' : 'ADD_MESSAGE';
    // // const _saveMessage = this.translate.instant(saveMessageTranslateParam);
    // // const _messageType = customer.LeadId > 0 ? MessageType.Update : MessageType.Create;
    // // const dialogRef = this.dialog.open(CustomerEditDialogComponent,{data: { customer }, disableClose: true });
    // dialogRef.afterClosed().subscribe(res => {
    //   if (!res) {
    //     return;
    //   }
    //   this.toastrService.success(_saveMessage);
    //   this.selectedActionId = 0;
    //   this.dataSource.loadCustomers(this.customerData);
    // });
  }
  customerData(customerData: any) {
    throw new Error('Method not implemented.');
  }

  redirectCustomerDetail(id: number, name: any, referBy: any,opportunityId? : any) {
    this.isDrawerOpen = true;
		this.lrmId = id;
		this.userName = name;
		this.opportunityId= opportunityId;
		console.log(referBy);
		// this.filterComponent.getByOpportunityFn();
		// if (referBy != "") {
			// this.myreferralsService.getCompanyByReferralCode(referBy)
			// .subscribe(response => {
			// 	this.referralList = response['data'];
			// 	this.referByCode = response['data'].ReferralCode;
			// 	console.log(this.referralList);
			// });
		// 	this.customersService
		// 		.getReferralTimeLine(referBy)
		// 		.subscribe((response) => {
		// 			this.referralList = response["data"];
		// 			console.log(this.referralList);
		// 			console.log(referBy);
		// 		});
		// }
		this.referByCode = "";
		this.currentScroll = window.scrollY;
		window.scrollTo(0, 0);
    this.disableScroll();
	}

  closeTimeline() {
    this.isDrawerOpen = false;
    
  }

	onDrawerClosed() {
		window.scrollTo(0, this.currentScroll);
		this.enableScroll();
	}

  enableScroll() {
		document.body.style.overflowY = '';
	}

	disableScroll() {
		document.body.style.overflowY = 'hidden';
	}

}
